// Reconstructed from the supplied production build; original component names were unavailable.
import { React } from "../../vendor/runtime.js";
const ResetOtpInput = ({ length: a = 6, value: n, onChange: i, error: l }) => {
  const [c, u] = React.useState(new Array(a).fill("")),
    m = React.useRef([]);
  React.useEffect(() => {
    n !== c.join("") && u(n.split("").concat(new Array(a).fill("")).slice(0, a));
  }, [n, a]);
  const f = (g, b) => {
      if (isNaN(g.value)) return;
      const y = [...c];
      ((y[b] = g.value),
        u(y),
        i({
          target: {
            name: "otp",
            value: y.join(""),
          },
        }),
        g.value && b < a - 1 && m.current[b + 1].focus());
    },
    x = (g, b) => {
      if (g.key === "Backspace" && !c[b] && b > 0) {
        const y = [...c];
        ((y[b - 1] = ""),
          u(y),
          i({
            target: {
              name: "otp",
              value: y.join(""),
            },
          }),
          m.current[b - 1].focus());
      }
    },
    p = (g) => {
      g.preventDefault();
      const b = g.clipboardData.getData("text/plain").slice(0, a);
      if (/^\d+$/.test(b)) {
        const y = b.split("").concat(new Array(a).fill("")).slice(0, a);
        (u(y),
          i({
            target: {
              name: "otp",
              value: b,
            },
          }));
        const w = Math.min(b.length, a - 1);
        m.current[w].focus();
      }
    };
  return (
    <div className={"mb-4"}>
      <label className={"block text-xs lg:text-sm font-medium text-gray-700 mb-3 text-center"}>
        {"Enter 6-digit OTP"}
      </label>
      <div className={"flex justify-center gap-1.5 lg:gap-3 mb-2"}>
        {c.map((g, b) => (
          <input
            key={b}
            ref={(y) => (m.current[b] = y)}
            type={"text"}
            maxLength={"1"}
            value={g}
            onChange={(y) => f(y.target, b)}
            onKeyDown={(y) => x(y, b)}
            onPaste={p}
            className={`w-8 h-10 lg:w-12 lg:h-14 text-center text-base lg:text-xl font-bold bg-gray-50 border-2 rounded-lg lg:rounded-xl transition-all duration-300 focus:outline-none focus:bg-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20 hover:bg-gray-100 ${l ? "border-red-500 bg-red-50" : "border-gray-200"} ${g ? "border-indigo-400 bg-indigo-50 text-indigo-700" : ""}`}
          />
        ))}
      </div>
      {l && (
        <div
          className={"text-red-500 text-xs flex items-center justify-center animate-slideInLeft"}
        >
          <svg className={"w-3 h-3 mr-1 flex-shrink-0"} fill={"currentColor"} viewBox={"0 0 20 20"}>
            <path
              fillRule={"evenodd"}
              d={
                "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              }
              clipRule={"evenodd"}
            />
          </svg>
          {l}
        </div>
      )}
    </div>
  );
};
export { ResetOtpInput };
